import styled from 'styled-components';
import { themeGet } from '@packages/ui';

// Inheriting Button from ui components causes weird styled-components problems in prod
export const TopRightElementBase = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  box-shadow: rgba(43, 18, 2, 0.07) 0px 0px 3px 2px;
  width: auto;
  max-width: 100px;
  height: 30px;

  font-size: ${themeGet.fontSize(0)};
  font-family: ${themeGet.fonts('brand')};
  font-weight: ${themeGet.fontWeight('normal')};
  text-align: center;

  background-color: ${themeGet.colors('white')};
  padding: ${themeGet.space(1)};

  position: absolute;
  z-index: 0;
  right: 0;
  border-radius: 6px 0 0 6px;
  line-height: normal;
  &:active,
  &:focus {
    background-color: ${themeGet.colors('white')};
  }
  &:hover {
    box-shadow: rgba(43, 18, 2, 0.2) 0px 0px 10px 2px;
  }
`;
